import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../../../app/providers/StoreProvider'
import { saveAuthTokens, clearAuthTokens } from '../../../../shared/lib/helpers/authStorage'
import {
    isRefreshTokenAvailable,
    isTokenAvailable
} from '../../../../shared/lib/helpers/tokenAvailability'
import { USER_REFRESH_TOKEN_KEY } from '../../../../shared/lib/const/localstorage'
import { UserActions } from '../slices/UserSlice'
import { AuthResponse, User } from '../types/UserSchema'

export const initAuthData = createAsyncThunk<void, void, ThunkConfig<string>>(
    'user/initAuthData',
    async (_, thunkApi) => {
        const { extra, dispatch } = thunkApi

        try {
            if (isRefreshTokenAvailable()) {
                const response = await extra.api.post<AuthResponse>('/auth/refresh', {
                    refresh_token: localStorage.getItem(USER_REFRESH_TOKEN_KEY)
                })

                saveAuthTokens(response.data.access_token, response.data.refresh_token)
                dispatch(UserActions.setUser(response.data.user))
                dispatch(UserActions.setAuth(true))
            } else if (isTokenAvailable()) {
                const response = await extra.api.get<User>('/auth/profile')
                dispatch(UserActions.setUser(response.data))
                dispatch(UserActions.setAuth(true))
            }
        } catch {
            clearAuthTokens()
            dispatch(UserActions.setAuth(false))
        } finally {
            dispatch(UserActions.initAuth())
        }
    }
)

export const logout = createAsyncThunk<void, void, ThunkConfig<string>>(
    'user/logout',
    async (_, thunkApi) => {
        const { dispatch } = thunkApi
        clearAuthTokens()
        dispatch(UserActions.logOut())
    }
)
